<template>
  <div class="SingleTrailSubscription">
    <div v-if="info" class="mrbox round border nofill">
      <p><label>route</label> <span>{{info.TrailName}}</span></p>
      <p><label>prijs</label> <span>{{info.Price}}</span></p>
      <p v-if="serverMessage" >{{serverMessage.LastName}}</p>
    </div>
    <form id="customer" @submit="processForm" class="mrbox round lightfill">
        <h1>Uw gegevens</h1>
        <label class="error" >{{invalidFirstName}}</label>
        <div class="controlrow edit">
          <input type="text" placeholder="voornaam" v-model="firstname" />
        </div>
        <label class="error" >{{invalidInfix}}</label>
        <label class="error" >{{invalidLastName}}</label>
        <table style="width: 100%; margin: 0;">
          <tr>
            <td style="width: 110px;">
              <div class="controlrow edit">
                <input type="text" placeholder="tussenvoegsels" v-model="infix" />
              </div>
            </td>
            <td style="width: 10px;"></td>
            <td>
              <div class="controlrow edit">
                <input type="text" placeholder="achternaam" v-model="lastname" />
              </div>
            </td>
          </tr>
        </table>
        <label class="error" >{{invalidEmail}}</label>
        <div class="controlrow edit">
          <input type="text" placeholder="e-mailadres" v-model="email" />
        </div>
        <label class="error" >{{invalidEmailConfirmation}}</label>
        <div class="controlrow edit">
          <input type="text" placeholder="bevestig e-mailadres" v-model="emailconfirm" />
        </div>
        <div id="confirm" class="mrbox" style="height: 44px;">
          <div class="bottombar" style="text-align: left; left: 8px;">
            <button type="submit" class="button lightfill">Bevestigen en betalen</button>
          </div>
        </div>
    </form>

    <ModalMessage v-if="modal.show" @close="modal.show = false">
      <template #header><h1>{{ modal.title }}</h1></template>
      <template #body><p v-html="modal.msg"></p></template>
    </ModalMessage>
  </div>
</template>

<script>
import ModalMessage from './ModalMessage.vue';

export default {
  data() {
    return {

      firstname: null,
      infix: null,
      lastname: null,
      email: null,
      emailconfirm: null,
      doValidate: false,
    };
  },
  name: 'SingleTrailSubscription',
  components: {
    ModalMessage,
  },
  mounted() {
    // After this line, router is ready
    this.$router.isReady().then(() => {
      // resolve the request
      this.$store.dispatch('getInfo', this.origin);
    });
    this.$store.dispatch('getMember').then(() => {
      if (this.member) {
        this.firstname = this.member.FirstName;
        this.infix = this.member.Infix;
        this.lastname = this.member.LastName;
        this.email = this.member.Email;
        this.emailconfirm = this.member.Email;
      }
    });
  },
  props: {
    msg: String,
  },
  computed: {
    modal() {
      return this.$store.state.modal;
    },
    info() {
      return this.$store.state.info;
    },
    member() {
      return this.$store.state.member;
    },
    serverMessage() {
      return this.$store.state.serverMessage;
    },
    error() {
      return this.$store.state.error;
    },
    origin() {
      return this.$route.query.origin;
    },
    invalidFirstName() {
      return this.validateNoHtml(this.firstname, 'voornaam', true);
    },
    invalidInfix() {
      return this.validateNoHtml(this.infix, 'tussenvoegsel', false);
    },
    invalidLastName() {
      return this.validateNoHtml(this.lastname, 'achternaam', true);
    },
    invalidEmail() {
      return this.validateEmail(this.email, 'e-mailadres', true);
    },
    invalidEmailConfirmation() {
      return this.validateEquals(this.email, this.emailconfirm, 'bevestig e-mailadres');
    },
  },
  methods: {
    processForm(event) {
      event.preventDefault();

      if (!this.validate()) {
        return;
      }

      const data = {
        Firstname: this.firstname,
        Infix: this.infix,
        Lastname: this.lastname,
        Email: this.email,
        TrailId: this.info.TrailId,
        SubscriptionSelection: 34,
      };
      this.$store.dispatch('postSubscription', data);
    },
    validateNoHtml(value, label, required) {
      if (!this.doValidate) {
        return null;
      }
      if (!value && required) {
        return `${label}: verplicht`;
      }
      if (value !== '') {
        const rx = /[\^~!@#$&%*()?\][{}<>|/\\]/;
        if (rx.test(value)) {
          return `${label}: de volgende letters mogen niet worden ingevoerd: \`~!@#$%^&*()?\\/[]{}<>|\\`;
        }
        return null;
      }
      return null;
    },
    validateEmail(value, label, required) {
      if (!this.doValidate) {
        return null;
      }
      if (!value && required) {
        return `${label}: verplicht`;
      }

      if (value !== '') {
        const rx = /^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/;
        if (!rx.test(value)) {
          return `${label}: Dit is geen geldig e-mailadres`;
        }
        return null;
      }
      return null;
    },
    validateEquals(value1, value2, label) {
      if (!this.doValidate) {
        return null;
      }
      if (value1 !== value2) {
        return `${label}: Invoer komt niet overeen`;
      }
      return null;
    },
    validate() {
      this.doValidate = true;
      return !(this.invalidFirstName || this.invalidInfix || this.invalidLastName
      || this.invalidEmail || this.invalidEmailConfirmation);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
